<div class="spinner-container">
  <mat-spinner></mat-spinner>
  @if (data.message) {
    <p class="loading-message">{{ data.message }}</p>
  }
</div>